export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7523.d5afb0ac.jpg";